const SettingsState = {
    settings: {},
    securityQuestions: []
};

export default SettingsState;